(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jszip"), require("xmldom"));
	else if(typeof define === 'function' && define.amd)
		define(["jszip", "xmldom"], factory);
	else if(typeof exports === 'object')
		exports["ePub"] = factory(require("jszip"), require("xmldom"));
	else
		root["ePub"] = factory(root["jszip"], root["xmldom"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_148__, __WEBPACK_EXTERNAL_MODULE_373__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition